var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import LinkExternalSvg from './link-external-01.icon.svg';
export const LinkExternalIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: LinkExternalSvg }));
_react_refresh_temp_1 = LinkExternalIcon;
$RefreshReg$(_react_refresh_temp_1, "LinkExternalIcon");
